import { useState, useEffect } from 'react';

import {
  Dropdown,
  DropdownItem,
  DropdownToggle,
  DropdownMenu,
  Modal,
  ModalHeader,
  ModalBody,
  ModalFooter,
  Button,
  Form, FormGroup
} from 'reactstrap';
import action3 from "../../../assets/images/action3.png";
import close from "../../../assets/images/close.png";
import { useSelector, useDispatch } from "react-redux";
import axiosInstance from '../../../helpers/axios';

import { userActions } from '../../../actions/user.actions';

const ApplicationStatusEnum = {
  InSubmission: 'In Submission',
  InReview: 'In Review',
  InSanction: 'In Sanction',
  InDisbursement: 'In Disbursement',
  Disbursed: 'Disbursed',
  Rejected: 'Rejected',
  Dropped: 'Dropped',
  OnHold: 'On Hold',
};
export default function MoveStatus(ApplicantId) {
  const doReload = ApplicantId.onSuccess ?? (() => window.location.reload());
  const showAssignOptions = ApplicantId.showAssignOptions ?? false;
  const droppedstate = useSelector((state) => state.Droppedstatuschange?.res)
  const reviewstate = useSelector((state) => state.Reviewstatuschange?.res)

  const dispatch = useDispatch();
  const user = null;const id = ApplicantId.ApplicantId.applicationId

  const rejectionReasons = [
    { label: "Credit Score", value: 1 },
    { label: "Low Income", value: 2 },
    { label: "FOIR", value: 3 },
    { label: "Document Issue", value: 4 },
    { label: "Bank Analysis Fail", value: 5 },
    { label: "Policy Breach", value: 6 },
    { label: "Fraud Flag", value: 7 },
    { label: "Other", value: 8 },
  ];

  const subRejectionReasons = [
    { label: "Wrong State", value: 1 },
    { label: "Self-Employed", value: 2 },
    { label: "Age Below Minimum", value: 3 },
    { label: "Low Salary", value: 4 },
    { label: "Repeat Application", value: 5 },
    { label: "Other Policy", value: 6 },
  ];

  const bankAnalysisSubReasons = [
    { label: "Low / Insufficient Salary Credits", value: 7 },
    { label: "Bounced EMIs / Cheque Returns", value: 8 },
    { label: "High Obligations (FOIR)", value: 9 },
    { label: "Salary Not Credited / Irregular", value: 10 },
    { label: "Statement Unreadable / Parse Fail", value: 11 },
    { label: "Suspected Tampered Statement", value: 12 },
    { label: "Insufficient Transaction History", value: 13 },
    { label: "Other (Bank Analysis)", value: 14 },
  ];
const name = ApplicantId.ApplicantId.name


  const [formLoader, setFormLoader] = useState(false);
  const [formStatusOpen, setStatusOpen] = useState(false);
  const [dropDownOpen, setDropDownOpen] = useState(false);
  const [descriptionText, setDescriptionText] = useState('');
  const [confirmationDialog, setConfirmationDialog] = useState(false);
  const [confirmationMessage, setConfirmationMessage] = useState('Hold On...');
  const [status, setStatus] = useState('Select Status');
  const [rejectionReason, setRejectionReason] = useState("");
  const [subRejectionReason, setSubRejectionReason] = useState("");
  const updateDroppedStatusUrl = `/admin/application/update-status`;
  const updateInReviewStatusUrl = `/end-user/submit/admin`;

  
  const popUpStatusForm = () =>{
    setStatusOpen(true);

  }
  
  const handleStatusChange = () => {
    if (status === 'Status') {
      alert('NO STATUS CHANGE !');
    } else if (status === 'Dropped') {
     
      const droppedData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.Dropped,
        notes: descriptionText,
      };

      
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
          setStatusOpen(!formStatusOpen);
          setConfirmationDialog(!confirmationDialog);
          setConfirmationMessage('Dropped Successfully');
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
           setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatusUrl,droppedData,user),[])
      }
     
       
    } else if (status === 'In Review') {
            
        const reviewData = {
          userId: ApplicantId.ApplicantId.userId,
        };
        if(reviewstate){
          if (reviewstate.message === 'Successful') {
            setFormLoader(!formLoader);
            setStatusOpen(!formStatusOpen);
            setConfirmationDialog(!confirmationDialog);
            setConfirmationMessage('Moved To In Review Successfully');
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
            setTimeout(() => setConfirmationDialog(false), 2000);
            setTimeout(() => doReload(), 500);
          }else{
            setConfirmationMessage("error");
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
             setTimeout(() => setConfirmationDialog(false), 2750);
          }
        }else{
          dispatch(userActions.fetchReviewstatuschange(updateInReviewStatusUrl,reviewData,user),[])
        }
    } 
    else if (status === 'On Hold') {
            
     
      const statusData = {
        userId: ApplicantId.ApplicantId.userId,
        applicationId: ApplicantId.ApplicantId.applicationId,
        status: ApplicationStatusEnum.OnHold,
        notes: descriptionText,
      };
      
      
   
      if(droppedstate){
        if (droppedstate.message === 'Successful') {
          setFormLoader(!formLoader);
            setStatusOpen(!formStatusOpen);
            setConfirmationDialog(!confirmationDialog);
          
          setConfirmationMessage('Moved to On Hold Successfully');
         setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
          setTimeout(() => setConfirmationDialog(false), 2000);
          setTimeout(() => doReload(), 500);
        }else{
          setConfirmationMessage("error");
          setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
           setTimeout(() => setConfirmationDialog(false), 2750);
        }
      }
       else{
        dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatusUrl,statusData,user),[])
       }
        
      } else if (status === 'Rejected') {
      if (!rejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select rejection reason");
        return;
      }
      if ((Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && !subRejectionReason) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please select sub rejection reason");
        return;
      }
      if (Number(rejectionReason) === 8 && descriptionText.trim().length < 10) {
        setConfirmationDialog(true);
        setConfirmationMessage("Please enter a Remarks note of at least 10 characters");
        return;
      }
        const statusData = {
          userId: ApplicantId.ApplicantId.userId,
          applicationId: ApplicantId.ApplicantId.applicationId,
          status: ApplicationStatusEnum.Rejected,
          notes: descriptionText,
          rejectionReason: Number(rejectionReason),
          rejectionSubReason: (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) ? subRejectionReason : null,
        };
        
        
     
        if(droppedstate){
          if (droppedstate.message === 'Successful') {
            setFormLoader(!formLoader);
              setStatusOpen(!formStatusOpen);
              setConfirmationDialog(!confirmationDialog);
            
            setConfirmationMessage('Moved to Rejected Successfully');
           setTimeout(() => setConfirmationDialog(!confirmationDialog), 2000);
            setTimeout(() => setConfirmationDialog(false), 2000);
            setTimeout(() => doReload(), 500);
          }else{
            setConfirmationMessage("error");
            setTimeout(() => setConfirmationDialog(!confirmationDialog), 2500);
             setTimeout(() => setConfirmationDialog(false), 2750);
          }
        }
         else{
          dispatch(userActions.fetchDroppedstatuschange(updateDroppedStatusUrl,statusData,user),[])
         }
          
        }
    else if (status === 'Send Self Service FeeMonk Link') {
      const applicant = ApplicantId.ApplicantId;
      const payload = {
        mobile: applicant.mobile,
        channelId: 6,
        courseName: applicant.courseName,
        instituteName: applicant.instituteName,
        courseFees: applicant.courseFees,
        loanTenure: applicant.tenure,
        firstName: applicant.name?.split(' ')[0] ?? '',
        lastName: applicant.name?.split(' ').slice(1).join(' ') ?? '',
        pincode: "",
        productId: "",
        userId: applicant.userId,
        applicationId: applicant.applicationId,
      };
      setFormLoader(true);
      console.log("Payload for Feemonk Assignment:", payload);
      axiosInstance.post('/admin/application/send-loan-application', payload, {
      })
        .then((res) => {
          setFormLoader(false);
          setStatusOpen(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Assigned to Feemonk Successfully');
          setTimeout(() => { setConfirmationDialog(false); doReload(); }, 2000);
        })
        .catch(() => {
          setFormLoader(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Error assigning to Feemonk');
          setTimeout(() => setConfirmationDialog(false), 2500);
        });
    } else if (status === 'Send Whastapp Consent') {
      const payload = {
        userId: ApplicantId.ApplicantId.userId,
        mobile: ApplicantId.ApplicantId.mobile,
      };
      setFormLoader(true);
      axiosInstance.post('/end-user/submit/send-whatsapp-consent', payload)
        .then(() => {
          setFormLoader(false);
          setStatusOpen(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Consent Sent Successfully');
          setTimeout(() => { setConfirmationDialog(false); doReload(); }, 2000);
        })
        .catch(() => {
          setFormLoader(false);
          setConfirmationDialog(true);
          setConfirmationMessage('Error sending Fibe consent link');
          setTimeout(() => setConfirmationDialog(false), 2500);
        });
    }

  };


  useEffect(()=>{
    handleStatusChange();
  },[droppedstate,reviewstate])
 
  

  const handleToggle = () => {
    setDropDownOpen(!dropDownOpen);
  };
  const handleDescriptionText = (text) => {
    setDescriptionText(text);
  };

  return (
    <div>
      <img  onClick={() => popUpStatusForm()} style={{cursor:'pointer',width:'1.1vw'}} src={action3} alt="resend consent"/>
      
      <Modal  isOpen={confirmationDialog} toggle={() => setConfirmationDialog(false)}>
        <ModalHeader toggle={() => setConfirmationDialog(false)}>Waiting For Confirmation</ModalHeader>
       
        <ModalBody>{confirmationMessage}</ModalBody>
      </Modal>
      {formStatusOpen && (
        <>
        <div
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          width: '100%',
          height: '100%',
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 999,
        }}
      ></div>
      
      <Modal style={{
        
        width:"400px",
        
        top:"10%",
       
        
        borderRadius:"10px",
      }}
      isOpen={formStatusOpen}>
        <div style={{backgroundColor:"#E9E9E9",borderTopLeftRadius:'10px',borderTopRightRadius:'10px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:'space-between',height:'60px',padding:"10px"}}>
                <p style={{fontFamily:"Inter-Medium",fontSize:'14px'}}>Update Status Here {status !== 'Send Self Service FeeMonk Link' && status !== 'Send Whastapp Consent' && <>( Submission to <span style={{fontFamily:"Inter-Medium",color:'#D32028'}}>{status}</span> )</>}</p>
                
                <img style={{height:'15px',width:'15px',marginTop:'12px'}} alt="" onClick={() => setStatusOpen(!formStatusOpen)} src={close}/>
            </div>
            </div>
           
            <div style={{marginTop:'10px'}}>
            <div style={{display:"flex",flexDirection:"row",justifyContent:"space-between",backgroundColor:'#FCF0F1',width:"100%",borderRadius:"10px"}}>
              <p style={{marginLeft:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}>Application ID <br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{id}</span></p>
               <p style={{marginRight:"15px",fontFamily:"Inter-Medium",fontSize:"14px",color:"#D32028"}}> Applicant Name<br/><span style={{fontFamily:"Inter-Medium",fontSize:"14px",color:"black"}}>{name}</span></p>
            </div>
         
          
        </div>
        
        <ModalBody >
          <Form>
          <FormGroup>
              <p style={{lineHeight:'10px',fontFamily:"Inter-Medium",fontSize:'14px'}}>Select Status*</p>
              <Dropdown isOpen={dropDownOpen} toggle={() => handleToggle()}>
                <DropdownToggle style={{lineHeight:'10px',textAlign:"left",height:'40px',width:'330px',backgroundColor:'white',color:'gray',fontFamily:"Inter-Medium",fontSize:'14px'}} >
                  {status}<span style={{ position: 'absolute', right: '50px', top: '50%', transform: 'translateY(-50%)' }}>
                    <svg xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12">
                      <path fill="currentColor" d="M1.5 4.5l4.5 4.5 4.5-4.5z" />
                    </svg>
                  </span>
                </DropdownToggle>
                <DropdownMenu>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => setStatus(e.target.innerText)}>
                    Rejected
                  </DropdownItem>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) =>{ 
                    setStatus(e.target.innerText)
                    setRejectionReason("");
                    setSubRejectionReason("");
                    }}>
                    Dropped
                  </DropdownItem>
                  <DropdownItem  style={{fontFamily:"Inter-Medium",fontSize:'14px'}}onClick={(e) =>{
                    setStatus(e.target.innerText)
                    setRejectionReason("");
                    setSubRejectionReason("");
                    }}>
                    In Review
                  </DropdownItem>
                  <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) =>{ 
                    setStatus(e.target.innerText)
                    setRejectionReason("");
                    setSubRejectionReason("");
                    }}>
                    On Hold
                  </DropdownItem>
                  {showAssignOptions && (
                    <>
                      <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => setStatus(e.target.innerText)}>
                        Send Self Service FeeMonk Link
                      </DropdownItem>
                      <DropdownItem style={{fontFamily:"Inter-Medium",fontSize:'14px'}} onClick={(e) => setStatus(e.target.innerText)}>
                        Send Whastapp Consent
                      </DropdownItem>
                    </>
                  )}

                </DropdownMenu>
              </Dropdown>

                  {status === 'Rejected' && (
                    <>
                      <p
                        style={{
                          marginTop: "20px",
                          lineHeight: "10px",
                          fontFamily: "Inter-Medium",
                          fontSize: "14px"
                        }}
                      >
                        Rejection Reason*
                      </p>

                      <select
                        value={rejectionReason}
                        onChange={(e) =>{
                          setRejectionReason(e.target.value);
                          setSubRejectionReason("");
                        } }
                        style={{
                          lineHeight: '10px',
                          textAlign: "left",
                          height: '40px',
                          width: '330px',
                          backgroundColor: 'white',
                          color: 'gray',
                          fontFamily: "Inter-Medium",
                          fontSize: '14px',
                          borderRadius: "5px",
                          border: "1px solid #ced4da",
                          paddingLeft: "10px",
                        }}
                      >
                        <option value="">
                          Select Rejection Reason
                        </option>

                        {rejectionReasons.map((reason) => (
                          <option
                            key={reason.value}
                            value={reason.value}
                          >
                            {reason.label}
                          </option>
                        ))}

                      </select>
                    </>
                  )}

                  {status === "Rejected" && (Number(rejectionReason) === 6 || Number(rejectionReason) === 5) && (
                    <>
                      <p
                        style={{
                          marginTop: "20px",
                          lineHeight: "10px",
                          fontFamily: "Inter-Medium",
                          fontSize: "14px"
                        }}
                      >
                        Sub Rejection Reason*
                      </p>

                      <select
                        value={subRejectionReason}
                        onChange={(e) => setSubRejectionReason(e.target.value)}
                        style={{
                          lineHeight: "10px",
                          textAlign: "left",
                          height: "40px",
                          width: "330px",
                          backgroundColor: "white",
                          color: "gray",
                          fontFamily: "Inter-Medium",
                          fontSize: "14px",
                          borderRadius: "5px",
                          border: "1px solid #ced4da",
                          paddingLeft: "10px",
                        }}
                      >
                        <option value="">Select Sub Rejection Reason</option>

                        {(Number(rejectionReason) === 6 ? subRejectionReasons : bankAnalysisSubReasons).map((reason) => (
                          <option key={reason.value} value={reason.value}>
                            {reason.label}
                          </option>
                        ))}
                      </select>
                    </>
                  )}
              {status !== 'Send Self Service FeeMonk Link' && status !== 'Send Whastapp Consent' && (                
                <>
                  <p style={{marginTop:"20px",lineHeight:'1px',fontFamily:"Inter-Medium",fontSize:'14px'}}>Remarks</p>
                  <input
                    type="text"
                    id="description"
                    placeholder="Write Description Here"
                    style={{borderRadius:"5px",borderStyle:"solid",borderWidth:"1px", height: '40px', width: '330px',fontFamily:"Inter-Medium",fontSize:'14px' }}
                    onChange={(e) => handleDescriptionText(e.target.value)}
                  />
                </>
              )}           
            </FormGroup>

          </Form>
        </ModalBody>
        <ModalFooter style={{display:"flex",flexDirection:"row",justifyContent:"center",backgroundColor:"#E9E9E9",height:'60px'}}>

         
          <Button style={{backgroundColor:"#D32028",color:"white",fontFamily:"Inter-Medium",fontSize:"13px",border:"solid",borderRadius:"5px",borderWidth:"1px",height:"30px"}} disabled={formLoader} onClick={() => handleStatusChange()}>
            Make Changes
          </Button>
        </ModalFooter>
      </Modal>
      
      </>
      )}
    </div>
  );
}


